import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppInitService } from 'src/app/app-init.service';
import { GridProperties } from 'src/app/shared/enums/gridProperties.enum';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { Tenant } from '../models/tenant.model';
import { ITenantGridData } from '../models/tenant_grid_data.model';
import { TenantGridParams } from '../models/tenant_grid_params.model';
import { TenantValidationResponse } from '../models/tenant_validation_response.model';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  //#region definite properties
  // The properties should be present for the application to work properly. These will be fetched inside of the constructor.
  // Because of that `baseUrl` `tenantController` and `appConfig` will be denoted with ! definite notation  
  private baseUrl!: string;
  private tenantController!: string;
  private appConfig!: AppConfigurations;
  //#endregion

  // public editTenant: any;
  constructor(private http: HttpClient, private appInitService: AppInitService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }


  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.tenantApi.baseApiUrl;
    this.tenantController = this.appConfig.tenantApi.tenantController;
  }

  /*
  * Get all the Active Inactive client data for grid
  */
  getTenantsGrid(): Observable<ITenantGridData[]> {
    return this.http.get<ITenantGridData[]>(`${this.baseUrl}${this.tenantController}`)
  }

  /*
  * Adding client data
  */
  addTenant(tenant: Tenant): Observable<any> {
    return this.http.post(`${this.baseUrl}${this.tenantController}`, tenant).pipe(
      map(() => tenant));
  }

  /*
  * Validating uniqueu client data (Checking whether its already in use) 
  */
  validateField(fieldName: string, value: string): Observable<TenantValidationResponse> {
    return this.http.get<TenantValidationResponse>(`${this.baseUrl}${this.tenantController}/Validate/${fieldName}/${value}`);
  }

  /*
  * Get all database server names
  */
  getDatabaseServers(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}${this.tenantController}/servers`);
  }

  /*
  * Get all the Active Inactive client data for grid - Search/ Pagination and sorting from the server side
  */
  getTenants(tenantGridParams: TenantGridParams) {
    const skip = ((tenantGridParams.pageInfo?.Page || 1) - 1) * (tenantGridParams.pageInfo?.PageSize || 25);
    return this.http.get(`${this.baseUrl}${this.tenantController}/grid?${GridProperties.SearchText}=${tenantGridParams.searchText
      }&${GridProperties.Page}=${tenantGridParams.pageInfo?.Page
      }&${GridProperties.PageSize}=${tenantGridParams.pageInfo?.PageSize
      }&${GridProperties.Skip}=${skip
      }&${GridProperties.SortDirection}=${tenantGridParams.sortInfo?.sortDirection}`)
  }

  private getTenantQueryParams(tenantGridParams: TenantGridParams): string {
    const skip = ((tenantGridParams.pageInfo?.Page || 1) - 1) * (tenantGridParams.pageInfo?.PageSize || 25);
    return `?SearchText=${tenantGridParams.searchText
      }&PageInfo.Page=${tenantGridParams.pageInfo?.Page
      }&PageInfo.PageSize=${tenantGridParams.pageInfo?.PageSize
      }&Pageinfo.Skip=${skip
      }&SortInfo.SortColumn=${tenantGridParams.sortInfo?.SortColumn
      }&SortInfo.SortDirection=${tenantGridParams.sortInfo?.sortDirection}`;
  }

  /*
  * Get the client data of a specific client
  */
  getTenant(clientCode: string): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.baseUrl}api/gettenants/`);

  }

}
